import { Subject } from 'rxjs';

import { ColorCodesEnum } from '../../enums';
import { SlideToggleControlInterface } from '../../interfaces';

import { BaseControl } from './base-control';

export class SlideToggleControl extends BaseControl<boolean | string | number> {
    private checked: boolean;

    public color: ColorCodesEnum;
    public expectBooleanValue: boolean;
    public checkedObserver: Subject<boolean>;

    constructor(data: SlideToggleControlInterface) {
        super(data);

        this.color = data.color;
        this.checked = data.checked;
        this.expectBooleanValue = data.expectBooleanValue;

        this.checkedObserver = new Subject();
    }

    setChecked(value: boolean, emitEvent = false): void {
        if (emitEvent) {
            this.checkedObserver.next(value);
        }

        this.checked = value;
    }

    getChecked(): boolean {
        return this.checked;
    }
}
